import { useState } from 'react';
import Sidebar from '../components/sidebar/Sidebar';
import AdminNav from '../components/adminNav/AdminNav';
const Wrapper = ({ children, searchBar }) => {
  const [side, setSide] = useState('-left-72 md:left-0');

  console.log(side);
  const openSidebar = () => {
    setSide('left-0 md:-left-72');
  };
  const closeSidebar = () => {
    setSide('-left-72 md:left-0');
  };

  return (
    <>
      <Sidebar side={side} closeSidebar={closeSidebar} />
      <AdminNav
        searchBar={searchBar}
        openSidebar={openSidebar}
        closeSidebar={closeSidebar}
        side={side}
      />
      <section
        className={`ml-0 ${
          side === 'left-0 md:-left-72' ? 'ml-0 ' : 'ml-0 md:ml-72'
        }   min-h-screen pt-24 px-4`}
      >
        <div className=" text-black md:px-4 px-0 py-6">{children}</div>
      </section>
    </>
  );
};
export default Wrapper;
